import { supabase } from '../../Servicios/supabaseClient.js';

// Abre un archivo privado de Storage con una URL firmada de 60 segundos.
async function openSigned(bucket, path) {
    const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 60);
    if (error) throw error;
    window.open(data.signedUrl, '_blank', 'noopener');
}

export async function downloadInvoice(path, notify) {
    if (!path) {
        notify('El PDF todavía no está disponible.', 'warn');
        return;
    }
    try {
        await openSigned('facturas', path.replace(/^facturas\//, ''));
    } catch (err) {
        console.error('Error descargando factura:', err.message);
        notify('No pudimos descargar la factura. Revisá tus permisos y probá de nuevo.', 'danger');
    }
}

export async function downloadExport(path, notify) {
    try {
        await openSigned('exports', path);
    } catch (err) {
        console.error('Error descargando export:', err.message);
        notify('No pudimos descargar el archivo del export.', 'danger');
    }
}
